import React from 'react'

import { Dropdown, Link, useModalContext } from '@sketch/components'
import { LaunchSketchAlert, routes } from '@sketch/modules-common'

import CopyLink from '../../../../../shares/components/ShareActionsDropdown/CopyLink'

import { ReactComponent as DocumentIcon } from '@sketch/icons/document-17'
import AppLogo from '@sketch/icons/logo-2x.png'

import styled from 'styled-components'

export const AppIcon = styled.img.attrs({ src: AppLogo })`
  width: 17px;
  height: 17px;
  margin-top: -1px; /* stylelint-disable-line scales/space */
`

const StyledLink = styled(Link)`
  font-weight: normal;
`

export interface LargeDocumentItemDropdownProps {
  identifier: string
  showOpenInSketchItem: boolean
}

export const LargeDocumentItemDropdown: React.FCC<
  LargeDocumentItemDropdownProps
> = props => {
  const { identifier, showOpenInSketchItem } = props
  const { showModal } = useModalContext()
  return (
    <>
      <Dropdown.Item icon={<DocumentIcon />}>
        <StyledLink
          variant="tertiary"
          target="_blank"
          to={routes.SHARE_VIEW.create({ shareID: identifier })}
        >
          View Document
        </StyledLink>
      </Dropdown.Item>
      <CopyLink shareIdentifier={identifier} />
      {showOpenInSketchItem && (
        <Dropdown.Item
          icon={<AppIcon />}
          onClick={() => {
            showModal(LaunchSketchAlert, {
              action: 'openInSketch',
              shareId: identifier,
            })
          }}
        >
          Open in Sketch
        </Dropdown.Item>
      )}
    </>
  )
}

export default LargeDocumentItemDropdown
